import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { HelpCircle } from "lucide-react";
import FadeInView from "./FadeInView";

/**
 * Consumer entry point on the attorney-facing landing page.
 *
 * Placed low on the page deliberately: the primary audience here is legal
 * professionals, so this offers members of the public a route to /ask without
 * competing with the attorney pitch above it.
 */
export default function NewLandingConsumerBand() {
  const navigate = useNavigate();

  return (
    <section className="nl-consumer-section">
      <FadeInView className="nl-consumer-band" y={28}>
        <div className="nl-consumer-inner">
          <div className="nl-consumer-icon" aria-hidden="true">
            <HelpCircle size={26} />
          </div>

          <div className="nl-consumer-copy">
            <p className="nl-consumer-eyebrow">Not a legal professional?</p>
            <h2 className="nl-consumer-headline">Have a legal question?</h2>
            <p className="nl-consumer-sub">
              Describe your situation, compare answers from multiple AIs, and
              get a plain-English summary — then find an attorney if you need
              one. No account required.
            </p>
            <p className="nl-consumer-fine">
              General legal information, not legal advice.
            </p>
          </div>

          <motion.button
            type="button"
            className="nl-consumer-btn nl-btn-unstyled"
            onClick={() => navigate("/ask")}
            whileHover={{ y: -2, scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            transition={{ duration: 0.2 }}
          >
            Ask a Legal Question →
          </motion.button>
        </div>
      </FadeInView>
    </section>
  );
}
